<div class="info-row" [class.info-row--inline]="layout() === 'inline'">
  <gc-text [variant]="labelVariant()">{{ label() | translate }}</gc-text>
  <gc-text [variant]="'paragraph'">{{ displayValue() }}</gc-text>
</div>
